import { useTranslation } from 'react-i18next';

export const useInventoryStatus = () => {
    const { t } = useTranslation();

    const inventoryData = {
        0: {
            text: t('inventory.status.text.inWork'),
            color: '#C4CCD7',
        },
        1: {
            text: t('inventory.status.text.free'),
            color: '#2AB96B',
        },
        2: {
            text: t('inventory.status.text.broken'),
            color: '#EC0818',
        },
        3: {
            text: t('inventory.status.text.decommissioned'),
            color: '#8A0000',
        },
    };

    return { inventoryData, t };
};
